class DynamicCardSection extends HTMLElement {
  connectedCallback() {
    this.buttons = this.querySelectorAll("[data-dynamic-card-video-toggle]");
    this.buttons.forEach((button) => {
      if (button.dataset.dynamicCardInitialized === "true") return;

      button.dataset.dynamicCardInitialized = "true";
      const card = button.closest("[data-dynamic-card]");
      const video = card?.querySelector("video");

      if (!video) {
        button.hidden = true;
        return;
      }

      video.addEventListener("play", () => this.setButtonState(button, false));
      video.addEventListener("pause", () => this.setButtonState(button, true));
      button.addEventListener("click", () => this.toggleVideo(video, button));
      this.setButtonState(button, video.paused);
    });
  }

  toggleVideo(video, button) {
    if (video.paused) {
      const playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(() => this.setButtonState(button, true));
      }
    } else {
      video.pause();
    }
  }

  setButtonState(button, paused) {
    button.dataset.videoPaused = paused ? "true" : "false";
    button.setAttribute("aria-label", paused ? button.dataset.playLabel : button.dataset.pauseLabel);
  }
}

if (!customElements.get("dynamic-card-section")) {
  customElements.define("dynamic-card-section", DynamicCardSection);
}
